var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "user form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_NAME_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionName",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.authConnection
                                                            .name,
                                                        expression:
                                                          "authConnection.name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name:
                                                        "authConnectionName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.authConnection.name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_URL"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_URL_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionUrl",
                                  attrs: { rules: "required|url", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes, errors }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-7"
                                                },
                                                [
                                                  _c("HttpUrl", {
                                                    attrs: {
                                                      name: "authConnectionUrl"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.authConnection.url,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "url",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "authConnection.url"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-2 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_HEADERS"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_HEADERS_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionHeaders",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-8 col-md-6"
                                                },
                                                [
                                                  _c("HttpHeaders", {
                                                    attrs: {
                                                      name:
                                                        "authConnectionHeaders"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.authConnection
                                                          .headers,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "headers",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "authConnection.headers"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_METHOD"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_METHOD_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionMethod",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("HttpMethodSelector", {
                                                    attrs: {
                                                      name:
                                                        "authConnectionMethod"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.authConnection
                                                          .method,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "method",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "authConnection.method"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.showBody
                      ? _c("Field", {
                          attrs: {
                            label: _vm.$t(
                              "INPUT_LABEL_AUTH_CONNECTION_CONTENT_TYPE"
                            ),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "INPUT_LABEL_AUTH_CONNECTION_CONTENT_TYPE_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      ref: "authConnectionContentType",
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 col-md-4"
                                                    },
                                                    [
                                                      _c(
                                                        "HttpContentTypeSelector",
                                                        {
                                                          attrs: {
                                                            name:
                                                              "authConnectionContentType"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.authConnection
                                                                .contentType,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.authConnection,
                                                                "contentType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "authConnection.contentType"
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value: "REQUIRED",
                                                        expression: "'REQUIRED'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                                  })
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showBody
                      ? _c("Field", {
                          attrs: {
                            label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_BODY"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "INPUT_LABEL_AUTH_CONNECTION_BODY_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c("ValidationProvider", {
                                      ref: "authConnectionBody",
                                      attrs: { rules: "required", slim: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ classes }) {
                                              return [
                                                _c("div", { class: classes }, [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-sm-4 col-md-4"
                                                    },
                                                    [
                                                      _c("HttpBody", {
                                                        attrs: {
                                                          "body-type":
                                                            _vm.authConnection
                                                              .contentType,
                                                          name:
                                                            "authConnectionBody"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.authConnection
                                                              .body,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.authConnection,
                                                              "body",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "authConnection.body"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value: "REQUIRED",
                                                        expression: "'REQUIRED'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                                  })
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_TIMEOUT"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_TIMEOUT_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionTimeout",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.authConnection
                                                            .pingTimeoutInMS,
                                                        expression:
                                                          "authConnection.pingTimeoutInMS"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      name:
                                                        "authConnectionTimeout",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.authConnection
                                                          .pingTimeoutInMS
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "pingTimeoutInMS",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("legend", { staticClass: "col-lg-offset-1 col-lg-10" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "TOKEN_USAGE_SECTION",
                            expression: "'TOKEN_USAGE_SECTION'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("TOKEN_USAGE_SECTION_TT"),
                              expression: "$t('TOKEN_USAGE_SECTION_TT')",
                              modifiers: { right: true }
                            }
                          ],
                          staticClass: "m-l-10 f-s-16"
                        },
                        [_c("i", { staticClass: "fa fa-question-circle" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_AUTH_HEADER"
                        ),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_AUTH_HEADER_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionHeaderName",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.authConnection
                                                            .authorizationHeaderName,
                                                        expression:
                                                          "authConnection.authorizationHeaderName"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      placeholder:
                                                        "Authorization",
                                                      type: "text",
                                                      name:
                                                        "authConnectionHeaderName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.authConnection
                                                          .authorizationHeaderName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "authorizationHeaderName",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_AUTH_CONNECTION_TOKEN_TYPE"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_TOKEN_TYPE_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionTokenType",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.authConnection
                                                            .defaultTokenType,
                                                        expression:
                                                          "authConnection.defaultTokenType"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Bearer",
                                                      name:
                                                        "authConnectionTokenType",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.authConnection
                                                          .defaultTokenType
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "defaultTokenType",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DEFAULT_EXPIRATION"
                        ),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DEFAULT_EXPIRATION_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "defaultTokenExpireInSeconds",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.authConnection
                                                            .defaultTokenExpireInSeconds,
                                                        expression:
                                                          "authConnection.defaultTokenExpireInSeconds "
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      placeholder: "3600",
                                                      name:
                                                        "defaultTokenExpireInSeconds",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.authConnection
                                                          .defaultTokenExpireInSeconds
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.authConnection,
                                                          "defaultTokenExpireInSeconds",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "fieldset",
                  [
                    _c("legend", { staticClass: "col-lg-offset-1 col-lg-10" }, [
                      _c("span", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "REQUEST_PARSING_SECTION",
                            expression: "'REQUEST_PARSING_SECTION'"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.right",
                              value: _vm.$t("REQUEST_PARSING_SECTION_TT"),
                              expression: "$t('REQUEST_PARSING_SECTION_TT')",
                              modifiers: { right: true }
                            }
                          ],
                          staticClass: "m-l-10 f-s-16"
                        },
                        [_c("i", { staticClass: "fa fa-question-circle" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_TOKEN"
                        ),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_TOKEN_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-8 col-md-8" },
                                  [
                                    _c("HttpParseSettings", {
                                      attrs: {
                                        name: "authConnectionDynamicToken"
                                      },
                                      model: {
                                        value:
                                          _vm.authConnection.parseSettings
                                            .dynamicAccessToken,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.authConnection.parseSettings,
                                            "dynamicAccessToken",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "authConnection.parseSettings.dynamicAccessToken"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_TYPE"
                        ),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_TYPE_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionDynamicTokenType",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-8 col-md-8"
                                                },
                                                [
                                                  _c("HttpParseSettings", {
                                                    attrs: {
                                                      name:
                                                        "authConnectionDynamicTokenType"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.authConnection
                                                          .parseSettings
                                                          .dynamicTokenType,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.authConnection
                                                            .parseSettings,
                                                          "dynamicTokenType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "authConnection.parseSettings.dynamicTokenType"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_EXPIRATION"
                        ),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_AUTH_CONNECTION_DYNAMIC_EXPIRATION_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "authConnectionDynamicExpiration",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-8 col-md-8"
                                                },
                                                [
                                                  _c("HttpParseSettings", {
                                                    attrs: {
                                                      name:
                                                        "authConnectionDynamicExpiration"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.authConnection
                                                          .parseSettings
                                                          .dynamicExpireIn,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.authConnection
                                                            .parseSettings,
                                                          "dynamicExpireIn",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "authConnection.parseSettings.dynamicExpireIn"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                        },
                        [
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                size: "sm",
                                "show-loader-on-form": _vm.showLoader
                              }
                            },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: _vm.currentAuthConnection.id
                                      ? "UPDATE"
                                      : "CREATE",
                                    expression:
                                      "currentAuthConnection.id ? 'UPDATE' : 'CREATE'"
                                  }
                                ]
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger m-l-15",
                            attrs: { type: "button" },
                            on: { click: _vm.cancel }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }